import React, {Component} from 'react';
import '../App.css';
import '../css/all.css';

import UpperMenu from '../components/upper_menu/upper_menu.component'
import compose from '../utils/compose'
import withNofeshService  from '../hoc/withNofeshService.hoc';
import Spinner from 'react-bootstrap/Spinner'
import HotelsList from '../components/hotels_list/hotels_list.component'
import ModalHotelDetails from '../components/hotels_list/modal_hotel_details.component'


class HotelsListPage extends Component {

  state = {
    loading:true,
    hotelsList: [],
    currentHotel :{},
    currentFacilities:{},
    modalHotelDisplay:false,
    loadingCurrentHotel:true

  }

  setModalHotelDisplayOpened = () => {
    this.setState({ modalHotelDisplay: true});
  }

  
  setModalHotelDisplayClosed = () => {
    this.setState({ modalHotelDisplay: false});
  }

  DisplayForHotelDetails = (hotelId) => {
      console.log('HotelsList DisplayForHotelDetails hotelId', hotelId);
      const { nofeshService } = this.props;

      nofeshService.getHotelDetails(hotelId).then( res  => {    
          console.log('DisplayForHotelDetails getHotelDetails res',res);

          this.setState({ currentHotel: res.data.hotel });
          this.setState({ currentFacilities: res.data.facilities });
          this.setState({ modalHotelDisplay: true });
          //this.setState({loading:false});             
      }); 
  }



  searchFilterHotels = (data) => {
    
    console.log('HotelsList searchFilterHotels data', data);
    const { nofeshService } = this.props;
    this.setState({loading:true});

    nofeshService.getHotelListFiltered(data).then( res  => {    
        console.log('searchFilterHotels getHotelListFiltered res',res);
        this.setState({hotelsList: res.data.hotelsList}); ; 
        this.setState({loading:false});             
    }); 
}


    componentDidMount = () => {

      const { nofeshService } = this.props;
      const { personData } = this.props;

      nofeshService.getHotelsList().then( res  => {    
        console.log('HotelsListPage componentDidMount getHotelsList res.data: ', res.data);
        let  resultObj = res.data;
        if (resultObj.status == 1) {
          this.setState( 
            {
              hotelsList: resultObj.hotelsList,
              ordersTitle: resultObj.message,
              loading:false
            });  
        }        
    }).catch(function(e) {
      console.error(e.message); 
    });   
  }



  render() {         



    return (      
      <React.Fragment>                
        <div className="hp_banner">
                <UpperMenu  
                     personData={this.props.personData} 
                     onLoggedOutRefresh={this.props.onLoggedOutRefresh}/>

        </div>
           


          {(this.state.modalHotelDisplay && this.state.currentHotel) ?     
            <ModalHotelDetails 
                hotel={this.state.currentHotel}
                facilities={this.state.currentFacilities}
                setModalHotelDisplayClosed={this.setModalHotelDisplayClosed} >
            </ModalHotelDetails>
          :null}


          <div className="hp_container"> 
                <div className="cntered-flex"> 
                {(this.state.loading) ?
                <React.Fragment>
                    <div className="cntered-flex directionRtl hotel_details_paddingTop20">
                      טוען נתונים ...
                      <Spinner
                          as="span"
                          animation="border"

                          role="status"
                          aria-hidden="true"                                        
                      />      
                    </div>
                    </React.Fragment>
                :                                     
                <HotelsList 
                  hotelsList={this.state.hotelsList} 
                  DisplayForHotelDetails={this.DisplayForHotelDetails}  
                  searchFilterHotels={this.searchFilterHotels} />     
                }  
            </div>
        </div>

        <div className="hp_footer">
        </div>
      </React.Fragment> 
    )
  }
}



export default compose(
    withNofeshService(),    
  )(HotelsListPage);



